import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  init () {
    this.state = {
      primo: false
    }

    this.primoInputs = document.querySelectorAll('[data-filter-primo]')
    this.primoReset = document.querySelector('[data-map-filter-primo-reset]')
    this.primoInputs.forEach(input => {
      input.addEventListener('change', this.handlePrimoChange.bind(this))
    })

    this.primoReset.addEventListener('click', this.onResetPrimo.bind(this))
  }

  onResetPrimo () {
    this.primoInputs.forEach(input => {
      input.checked = false
    })
    this.state.primo = false
    this.primoReset.classList.add('hidden')

    window._selection = this.state
    const update = new CustomEvent('map:selection-primo')
    window.dispatchEvent(update)
  }

  handlePrimoChange (e) {
    const { value } = e.target

    this.state.primo = value
    this.primoReset.classList.remove('hidden')

    window._selection = this.state
    const update = new CustomEvent('map:selection-primo')
    window.dispatchEvent(update)
  }
}
